module.exports = __webpack_public_path__ + "img/alter_icon.3692330e.svg";